// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__4Pk87","rootCenter":"LoadMoreObserver_rootCenter__1an4c","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3aBw9"};